<h1 mat-dialog-title>Found suggestions</h1>
<div mat-dialog-content>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Replaced by
        </mat-panel-title>
        <mat-panel-description>
          {{suggestions.replacedBy.length}} suggestion{{suggestions.replacedBy.length === 1 ? '' : 's'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      Clicking on an image will select it to be reviewed or edited (and suspend this dialog for now) <br><br>
      <div *ngFor="let suggestion of suggestions.replacedBy; let i = index" class="horizontal-center">
        <div id="image-viewer">
          <img [src]="suggestion.edited_data_url_base64 ? suggestion.edited_data_url_base64 : suggestion.source_url" width="450" (click)="onClickReplacingImage(suggestion)">
        </div>
        <!--<div id="image-details" *ngIf="!(componentOptions && componentOptions.hideSizeInfo)">
          Size: {{image.dimension.width}}x{{image.dimension.height}} (~{{image.dimension.ratio.toFixed(mainConfig.imageRatioFractionDigits)}})
        </div>-->
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          Made OER
        </mat-panel-title>
        <mat-panel-description>
          {{suggestions.madeOer.length}} suggestion{{suggestions.madeOer.length === 1 ? '' : 's'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div fxLayout="column" fxLayoutAlign="space-around start" *ngFor="let suggestion of suggestions.madeOer; let i = index" class="made-oer-suggestion" (click)="onClickMadeOerSuggestion(suggestion)">
        <p>Title: {{suggestion.title || 'unknown'}}</p>
        <p>Author: {{suggestion.author_name || 'unknown'}}</p>
        <p>License: {{suggestion.license_name}} {{suggestion.license_version}}</p>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

</div>
